import { TFunction, t } from 'i18next';
import { Button, InputText, Text } from '@pentabd/ui';
import { getAccess } from '@utils/accessControl';
import { IconEye, IconSearch } from '@pentabd/icons';
import { numberLanguageFormatter } from '@utils/utils';

export const constituencyWiseResultColumn = ({
  t,
  election_schedule_id,
}: {
  t: TFunction<'translation', undefined>;
  election_schedule_id?: string;
}) => [
  {
    id: 1,
    name: t('CONSTITUENCY_WISE_RESULTS.BODY.TABLE.COLUMN.CONSTITUENCY_NAME'),
    key: 'constituencyName',
    render: (data: string) => <Text className="text-nowrap">{data}</Text>,
  },

  {
    id: 2,
    name: t('CONSTITUENCY_WISE_RESULTS.BODY.TABLE.COLUMN.ZILLA_NAME'),
    key: 'zilla_name',
    render: (data: string) => <Text className="text-nowrap">{data}</Text>,
  },

  // {
  //   id: 3,
  //   name: (
  //     <div className="header_text_align_center">
  //       {t('CONSTITUENCY_WISE_RESULTS.BODY.TABLE.COLUMN.TOTAL_VOTING_CENTER')}
  //     </div>
  //   ),

  //   key: 'total_voting_center',
  //   render: (data: string) => (
  //     <div className="d-flex justify-content-center">
  //       <Text className="text-nowrap">{data}</Text>
  //     </div>
  //   ),
  // },
  {
    id: 4,
    name: (
      <div className="header_text_align_center">
        {t('CONSTITUENCY_WISE_RESULTS.BODY.TABLE.COLUMN.DONE_VOTING_CENTER')}
      </div>
    ),
    key: 'done_voting_center',
    render: (data: string) => (
      <div className="d-flex justify-content-center">
        <Text className="text-nowrap">{data}</Text>
      </div>
    ),
  },
  {
    id: 5,
    name: (
      <div className="header_text_align_center">
        {t('CONSTITUENCY_WISE_RESULTS.BODY.TABLE.COLUMN.VOTE_RECEIVED')}
      </div>
    ),
    key: 'vote_count_value',
    render: (data: string) => (
      <div className="d-flex justify-content-center">
        <Text className="text-nowrap">{data}</Text>
      </div>
    ),
  },
  {
    id: 6,
    name: (
      <div className="header_text_align_center">
        {t('CONSTITUENCY_WISE_RESULTS.BODY.TABLE.COLUMN.PERCENTAGE')}
      </div>
    ),
    key: 'percentage',
    render: (data: string) => (
      <div className="d-flex justify-content-center">
        <Text className="text-nowrap">{data}</Text>
      </div>
    ),
  },
  {
    id: 7,
    name: t('CONSTITUENCY_WISE_RESULTS.BODY.TABLE.COLUMN.ACTION'),
    key: 'id',
    render: (data: number) => (
      <Button
        className="p-5"
        onClick={() => {
          if (getAccess(data)) {
            window.open(
              `${window.location.origin}/center-wise-results/${data}?election_schedule_id=${election_schedule_id}`,
            );
          }
        }}
        disabled={!getAccess(data)}
      >
        <IconEye size="17" />
      </Button>
    ),
  },
];

export function HeaderExtensionCenterWiseResult({
  isLoading,
  constituencyWiseResults,
  handleQuery,
  query,
}: {
  isLoading: boolean;
  constituencyWiseResults: any[];
  handleQuery: (name: string, value: string | number) => void;
  query: {
    division: string;
    timeSlot: string;
    percentage: number | string;
  };
}) {
  return {
    leftComponents: [
      !isLoading ? (
        <div>
          <Text className="subtitle2 text-nowrap" weight="bold">
            {`${t(
              'CONSTITUENCY_WISE_RESULTS.BODY.TABLE.COLUMN.TOTAL_CONSTITUENCY_NAME',
            )}: ${numberLanguageFormatter(
              constituencyWiseResults?.length || 0,
            )}`}
          </Text>
        </div>
      ) : (
        <></>
      ),
    ],
    rightComponents: [
      <InputText
        name="percentage"
        onChange={(e) => {
          if (e.target.value) {
            const percentage = Number(e.target.value);

            if (percentage >= 0 && percentage <= 100) {
              handleQuery('percentage', percentage);
            }
          } else {
            handleQuery('percentage', '');
          }
        }}
        value={query?.percentage as string}
        prefix={<IconSearch fill="dark" size="20" />}
        size="sm"
        placeholder={t(
          'CONSTITUENCY_WISE_RESULTS.BODY.TABLE.SEARCH_BY_PERCENTAGE',
        )}
        type="number"
        controlling
      />,
    ],
  };
}
